export default "__VITE_ASSET__DhWMREtC__"